(function () {
    // Configuration
    // If running inside Shopify, we might want to get the API URL from the embed settings
    const root = document.querySelector('#debora-root');
    const API_URL = root?.dataset?.apiUrl || 'https://debora-ai-2-0.vercel.app';
    const ENDPOINT = `${API_URL}/api/track`;

    // 1. Session Management
    // We use a persistent local storage ID to track returning users across sessions
    let sessionId = localStorage.getItem('debora_session_id');
    if (!sessionId) {
        // Simple fallback UUID generator if crypto is strictly not available (rare in modern browsers)
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            sessionId = crypto.randomUUID();
        } else {
            sessionId = 'session-' + Math.random().toString(36).substring(2) + Date.now().toString(36);
        }
        localStorage.setItem('debora_session_id', sessionId);
    }

    // Expose for Sommelier
    window.DEBORA_SESSION_ID = sessionId;

    const sendEvent = (type, payload = {}) => {
        const body = {
            session_id: sessionId,
            event_type: type,
            url: window.location.href,
            timestamp: new Date().toISOString(),
            user_context: {
                customer_id: root?.dataset?.customerId || null,
                email: root?.dataset?.customerEmail || null,
                cart_count: parseInt(root?.dataset?.cartCount || '0'),
                acquisition: {
                    source: new URLSearchParams(window.location.search).get('utm_source'),
                    medium: new URLSearchParams(window.location.search).get('utm_medium'),
                    gclid: new URLSearchParams(window.location.search).get('gclid') || undefined
                }
            },
            payload
        };

        // Use sendBeacon for visibility/unload events if possible (fire and forget)
        // But sendBeacon implies POST with text/plain or blob, json needs blob
        const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });

        if (navigator.sendBeacon && type === 'page_hide') {
            navigator.sendBeacon(ENDPOINT, blob);
        } else {
            fetch(ENDPOINT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
                keepalive: true // Crucial for events fired near page transitions
            }).catch(e => {
                // Silent fail to not spam console in production
                if (window.location.hostname === 'localhost') console.warn('[Debora Analytics] Error:', e);
            });
        }
    };

    // 2. Page View (Immediate)
    // We wait for DOM Content Loaded to ensure title is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => sendEvent('page_view', { title: document.title }));
    } else {
        sendEvent('page_view', { title: document.title });
    }

    // 3. Heartbeat (Time on Page)
    // Send a 'heartbeat' every 120 seconds if the page is visible
    setInterval(() => {
        if (document.visibilityState === 'visible') {
            sendEvent('heartbeat', { time_on_page_est: 120 });
        }
    }, 120000);

    // 4. Cart Listeners
    // We listen for the custom event dispatched by debora-atc.js
    window.addEventListener('debora:cart:added', (e) => {
        sendEvent('add_to_cart', {
            product_handle: e.detail?.handle,
            variant_id: e.detail?.variantId
        });
    });

    console.log('📊 Debora Analytics Active', { sessionId });
})();
